// 配置路由相关的信息
import VueRouter from 'vue-router'
import Vue from 'vue'
 
import Home from '../pages/home'
import Tutor from '../pages/tutor'
import Team from '../pages/team'
import Paper from '../pages/paper'
import Download from '../pages/download'
import Honor from '../pages/honor'
import Innovation from '../pages/innovation'
import Influence_Contribution from '../pages/influence_contribution'
import Service from '../pages/service'

 
// 1.通过Vue.use(插件), 安装插件
Vue.use(VueRouter)
 
// 2.创建VueRouter对象
const routes = [
  // {
  //   path: '',
  //   // redirect重定向
  //   redirect: '/home'
  // },
  {
    path: '',
    name:'home',
    component: Home
  },
  {
    path: '/tutor',
    name:'tutor',
    component: Tutor
  },
  {
    path: '/team',
    name:'team',
    component: Team
  },
  {
    path: '/paper',
    name:'paper',
    component: Paper
  },
  {
    path: '/honor',
    name:'honor',
    component: Honor
  },
  {
    path: '/download',
    name:'download',
    component: Download
  },
  {
    path: '/innovation',
    name:'innovation',
    component: Innovation
  },
  {
    path: '/influence_contribution',
    name:'influence_contribution',
    component: Influence_Contribution
  },
  {
    path: '/service',
    name:'service',
    component: Service
  },
]
const router = new VueRouter({
  // 配置路由和组件之间的应用关系
  routes,
  mode: 'hash',
  linkActiveClass: 'active'
})

export default router
